import { SourcingAnalytics } from 'api-clients/monolith';

import { MetricIndicator } from './metric-indicator';

interface MetricsProps {
  analyticsData: SourcingAnalytics;
}

const METRIC_ORDER: (keyof SourcingAnalytics)[] = [
  'budget_spent',
  'hired_count',
  'average_cph',
  'applied_count',
  'average_cpa',
];

export function Metrics({ analyticsData }: MetricsProps) {
  return (
    <div className="flex flex-row justify-between px-6 py-4">
      {METRIC_ORDER.map(key => (
        <MetricIndicator key={key} metricKey={key} value={analyticsData[key]} />
      ))}
    </div>
  );
}

Metrics.Skeleton = function MetricsSkeleton() {
  return (
    <div className="flex flex-row justify-between px-6 py-4">
      {METRIC_ORDER.map(key => (
        <MetricIndicator.Skeleton key={key} metricKey={key} />
      ))}
    </div>
  );
};
